export const domain = "https://logicuniversityweb.web.app/";

export const api = "https://backendad.azurewebsites.net/";
